// Imports
// ------------
import styled, { css } from 'styled-components';
// import { breakup, Section } from '@tackl';

// Exports
// ------------
export const Jacket = styled.div`
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    pointer-events: none;
`;

export const MarqueeJacket = styled.div((props) => css`
        transition: all 1s ease;
        position: relative;
        display: block;
        width: 100%;

        white-space: nowrap;
        overflow-y: visible;
        pointer-events: none;
    `
);

export const MarqueeContent = styled.div(props => css`
    display: inline-flex;
`);

export const Words = styled.span(props => css`
    display: flex;
    align-content: center;
    white-space: pre;

    margin-right: 12rem;

    font-family: ${props.theme.fancy};
    font-size: 18.2vw;
    text-indent: -1vw;
    line-height: 1;
    color: ${props.isDark ? props.theme.bc3 : props.theme.black};
`);